export const COLORS = {
  // Brand Colors
  primary: '#D96C4F', // clip-500
  primaryLight: '#F5D6CE', // clip-200
  primaryDark: '#873321', // clip-800
  
  // Neutral
  secondary: '#374151', // gray-700
  bg: '#f8fafc', // gray-50/slate-50
  
  // Text
  text: {
    main: '#111827', // gray-900
    muted: '#6b7280', // gray-500
    light: '#9ca3af', // gray-400
  },
  
  // Status
  status: {
    success: '#22c55e',
    warning: '#f59e0b',
    danger: '#ef4444',
    info: '#3b82f6',
  },
  
  // Charts Specific
  charts: {
    gradientStart: '#D96C4F',
    gradientEnd: '#E48874',
    grid: '#e5e7eb',
    tooltipBg: '#ffffff',
  }
};